import type { Area, Category, Department } from '../models/issues/issue';

type DraftIssueSelections = {
  area?: Area;
  areaKey?: string;
  department?: Department;
  departmentKey?: string;
  category?: Category;
  categoryKey?: string;
};

const findArea = (areas: Area[], selection: Area | undefined) => {
  if (!selection) {
    return undefined;
  }

  return areas.find((area) => area.key === selection.key);
};

const findDepartment = (
  departments: Department[],
  selection: Department | undefined
) => {
  if (!selection) {
    return undefined;
  }

  return departments.find((department) => department.key === selection.key);
};

const findCategory = (
  categories: Category[],
  selection: Category | undefined
) => {
  if (!selection) {
    return undefined;
  }

  return categories.find((category) => category.key === selection.key);
};

export const resolveDraftIssueSelections = (
  draftIssue: DraftIssueSelections,
  areas: Area[]
) => {
  const area = draftIssue.areaKey
    ? areas.find((candidate) => candidate.key === draftIssue.areaKey)
    : findArea(areas, draftIssue.area);

  const department = draftIssue.departmentKey
    ? area?.departments.find(
        (candidate) => candidate.key === draftIssue.departmentKey
      )
    : findDepartment(area?.departments ?? [], draftIssue.department);

  const category = draftIssue.categoryKey
    ? department?.categories.find(
        (candidate) => candidate.key === draftIssue.categoryKey
      )
    : findCategory(department?.categories ?? [], draftIssue.category);

  return {
    area,
    department,
    category,
  };
};
